import React from "react";

function CustomButton({
    onClick,
    title,
    className = "w-full",
    iconBefore = () => null,
    iconAfter = () => null,
}) {
    return (
        <button
            onClick={onClick}
            className={`flex items-center justify-center rounded-xl text-white px-8 py-2 border-custom-yellow hover:bg-[#ffffff1a] ${className}`}
        >
            {iconBefore()}
            {title}
            {iconAfter()}
        </button>
    );
}

export default CustomButton;
